import FeatureTicker from "./feature-ticker";
import Panel from "components/ui/panel";

/* Auth hero. The old panel was a light cyan gradient carrying dark type; the
   brand has exactly two green treatments and this is the `deep` one, so the type
   goes light and the card goes to rgba(255,255,255,.12) per `.is-ondeep`.

   Copy: the previous subhead read "AI-powered clinical documentation", which is
   on the never-say list. Replaced with an approved tagline. The rest of the
   string sweep is still its own pass. */

const AVATAR_INITIALS = ["SM", "JT", "TH"];

const ValuePropPanel = () => (
  <Panel
    ground="deep"
    className="flex h-full min-h-screen select-none flex-col rounded-none px-8 py-7"
  >
    {/* The mark, not the lockup. Standard 8: the lockup's wordmark is dark and
        disappears on the deep green ground, which is why the footer uses the mark.
        Inverting the lockup would be a deviation, not a fix. */}
    <div className="mb-5">
      <img src="/brand-mark.png" alt="NirvaScribe" className="h-9 w-9" />
    </div>

    <div className="mb-8">
      <FeatureTicker dark />
    </div>

    <div className="flex-1" />

    <div className="mb-4">
      <h1 className="mb-2 font-display text-h3 font-normal leading-[1.15] tracking-[-0.015em] text-white">
        Notes done before
        <br />
        the door closes.
      </h1>
      <p className="font-body text-ui-sm text-white/70">For Australian clinicians.</p>
    </div>

    <div className="mb-4 flex items-center gap-2.5">
      <div className="flex -space-x-2">
        {AVATAR_INITIALS.map((initials) => (
          <div
            key={initials}
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-deep bg-accent-light font-body text-[9px] font-medium text-deep"
          >
            {initials}
          </div>
        ))}
      </div>
      <span className="font-body text-ui-xs text-white/70">Trusted by Aussie clinicians</span>
    </div>

    <div className="rounded-ns border border-solid border-white/12 bg-white/12 p-[14px]">
      <p className="mb-3 font-body text-ui-xs leading-[1.55] text-white/90">
        "NirvaScribe has been a genuine time saver. The templates are flexible,
        and the scribe does a great job capturing what matters clinically."
      </p>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full bg-accent-light font-body text-[9px] font-medium text-deep">
            TH
          </div>
          <div>
            <p className="font-body text-ui-xs font-medium leading-tight text-white">Thashmi H.</p>
            <p className="font-body text-meta leading-tight text-white/60">Audiologist · Melbourne</p>
          </div>
        </div>
        <span className="text-ui-sm tracking-tight text-accent" aria-label="5 stars">
          ★★★★★
        </span>
      </div>
    </div>
  </Panel>
);

export default ValuePropPanel;
